import ArrowBack from '@mui/icons-material/ArrowBack'
import { Box, Button, Card, CardContent, CardHeader, Divider, Grid, Switch, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const Manage = () => {
    const navigate = useNavigate();
    return (
        <div className="col-lg-9 col-12">
        <Grid container justifyContent="center">
            <Grid item lg={12} xs={12}>
                <Card elevation={3} sx={{ mt: 3 }}>
                    <CardHeader
                        avatar={
                            <ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />
                        }
                        title="Career"
                        subheader=" By turning on strict filters, you will only see matches that exactly meet your specified criteria."
                        titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }} />
                    <CardContent className='text-left'>
                        {[
                            { title: "Partner's Age", value: '28 years - 36 years' },
                            { title: "Partner's Country", value: 'India' },
                            { title: "Partner's City/State", value: 'Nagpur, Maharashtra' },
                            { title: "Partner's Marital Status", value: 'Never Married' },
                            { title: "Partner's Income", value: 'Rs. 3 Lakh - Rs. 5 Lakh, $0 - and above' },
                            { title: "Partner's Religion", value: 'Hindu' },
                            { title: "Partner's Caste", value: 'Mali' },
                            { title: "Partner's Mother Tongue", value: 'Marathi' },
                        ].map((item, index) => (
                            <Box
                                key={index}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={3}
                                mb={2}
                            >
                                <Box>
                                    <Typography variant="subtitle1">{item.title}</Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {item.value}
                                    </Typography>
                                </Box>
                                <Switch color="primary" />
                            </Box>
                        ))}
                        <Divider sx={{ my: 3 }} />
                        <Box textAlign="center">
                            <Button variant="contained" color="primary" href="edit_profile.html">
                                Save
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
        </div>
    )
}
